export default __webpack_public_path__ + "static/gwpark-5ace8bb003e0313d9ed726667ced38ce.png";